export class UserBasicDataResponse{
    public id! : string;
    public businessId! : string;
    public firstName! :string;
    public lastName! : string;
    public email! : string;
    public phoneNumber? : string;
    public mobilePhoneNumber? : string;
    public streetAddress1! : string;
    public streetAddress2? : string;
    public city! : string;
    public state! : string;
    public zipCode! : string;
    public country! : string;
    public entityLegalNam? : string;
    public entityTradeName? : string;
    public entityStreetAddress1? : string;
    public entityStreetAddress2? : string;
    public entityCity? : string;
    public entityState? : string;
    public entityZipCode? : string;
    public entityCountry? : string;
}